<template>
  <v-card :flat="flat" :color="transparent ? 'transparent' : ''" :dark="dark">
    <h5 v-text="$t('text.service_provider')" />

    <br>
    <v-img src="/api2/Report/logo" height="80" max-width="300" contain :alt="userInfo.Provider.CompanyName"
      position="left">
    </v-img>
    {{$t('text.name')}}: {{userInfo.Provider.CompanyName}} <br>
    <v-icon size="18" class="mr-1">mdi-email</v-icon> {{userInfo.Provider.Email}} <br>
    <v-icon size="18" class="mr-1">mdi-phone</v-icon> {{userInfo.Provider.Telephone}} <br>
  </v-card>
</template>


<script>
export default {
  name: "ServiceProviderContactCard",
  props: {
    dark: Boolean,
    transparent: Boolean,
    flat: Boolean,
  },
  components: {},

  data() {
    return {};
  },

  methods: {},

  computed: {
    userInfo() {
      if (this.$store.state.userInfo) return this.$store.state.userInfo;
      return { Customer: {}, Provider: {} };
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped>
</style>